import type {
  KlevuFilterResultOptions,
  KlevuFilterResultRating,
  KlevuFilterResultSlider,
} from "@klevu/core";
import type { Component } from "vue";
import type { FilterManagerFilterOptions } from "~/modules/catalog/classes/FilterManager/FilterManagerFilterOptions";
import type { FilterManagerFilterNumber } from "~/modules/catalog/classes/FilterManager/FilterManagerFilterNumber";

export interface CatalogFilterPortalPrepared {
  component: Component;
  payload: {
    filter:
      | KlevuFilterResultOptions
      | KlevuFilterResultSlider
      | KlevuFilterResultRating
      | FilterManagerFilterOptions
      | FilterManagerFilterNumber;
    [key: string]: any;
  };
}

export enum FiltersMode {
  all,
  search,
  catalog,
  // Box finder: categories render as checkboxes (multi-select, stay on page).
  boxFinder,
}
